/*
 * @Author: 刘小博
 * @Date: 2023-02-07 14:31:17
 * @LastEditTime: 2023-03-06 18:28:58
 * @LastEditors: 刘小博
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\behavior-manage\oa-work-manage\modules\workManageRouter.js
 * OA办公
 */
const workManageRouter = [
  // oaOA审批
  {
    path: '/behaviorManage/oa/approve-list',
    name: 'behaviorManageOaApproveList',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageOa" */
      //   '@/views/behaviorManage/oa/ApproveList.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManageOa" */
        '@/views/behavior-manage/oa-work-manage/oa-approval/Page.vue'
      ),
    meta: {
      SecondaryMenu: 'OA办公', //二级菜单
      title: 'OA审批',
    },
  },
  // oaOA审批 审批中心
  {
    path: '/behaviorManage/oa/approve-center/:id/:name/:approval_flow_scene/:is_doc_helper',
    name: 'behaviorManageOaApproveCenter',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageOa" */
      //   '@/views/behaviorManage/oa/ApproveCenter.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManageOa" */
        '@/views/behavior-manage/oa-work-manage/oa-approval/ApprovalCenter.vue'
      ),
    meta: {
      SecondaryMenu: 'OA办公', //二级菜单
      title: '审批中心',
      breadcrumb: [{
        title: 'OA审批',
        name: 'behaviorManageOaApproveList',
      }, ],
    },
  },
  // oaOA审批 新建审批
  {
    path: '/behaviorManage/oa/approve-create/:id/:name/:approval_flow_scene',
    name: 'behaviorManageOaApproveCreate',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageOa" */
      //   '@/views/behaviorManage/oa/ApproveCreate.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManageOa" */
        '@/views/behavior-manage/oa-work-manage/oa-approval/Add.vue'
      ),
    meta: {
      SecondaryMenu: 'OA办公', //二级菜单
      title: '新建审批',
    },
  },

  // oa审批详情 from -1 OA审批 1审批中心  is_replace = 2 全部审批
  {
    path: '/behaviorManage/oa/approve-details/:id/:from/:is_replace',
    name: 'behaviorManageOaApproveDetails',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageOa" */
      //   '@/views/behaviorManage/oa/ApproveDetails.vue'
      // ),  //待删除文件
    import(
      /*webpackChunkName:"behaviorManageOa" */
      '@/views/behavior-manage/oa-work-manage/oa-approval/Detail.vue'
    ),    //新迁移文件
    meta: {
      SecondaryMenu: 'OA办公', //二级菜单
      title: '审批详情',
    },
  },
  // 问题反馈
  {
    path: '/behaviorManage/problem',
    name: 'behaviorManageProblemPage',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageOa" */
      //   '@/views/behaviorManage/problem/Page.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManageOa" */
        '@/views/behavior-manage/oa-work-manage/problem-feedback/Page.vue'
      ),
    meta: {
      SecondaryMenu: 'OA办公', //二级菜单
      title: '问题反馈',
    },
  },
  // 问题反馈 详情
  {
    path: '/behaviorManage/problem/detail/:question_id',
    name: 'behaviorManageProblemDetail',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageOa" */
      //   '@/views/behaviorManage/problem/Detail.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManageOa" */
        '@/views/behavior-manage/oa-work-manage/problem-feedback/Detail.vue'
      ),
    meta: {
      SecondaryMenu: 'OA办公', //二级菜单
      title: '问题反馈',
      breadcrumb: [{
        title: '问题反馈',
        name: 'behaviorManageProblemPage',
      }, ],
    },
  },
  // oa 模版配置 模版列表
  {
    path: '/behaviorManage/oa/template-list',
    name: 'behaviorManageOaTemplateList',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageOa" */
      //   '@/views/behaviorManage/oa/TemplateList.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManageOa" */
        '@/views/behavior-manage/oa-work-manage/oa-template-config/Page.vue'
      ),
    meta: {
      SecondaryMenu: 'OA办公', //二级菜单
      title: 'OA模版配置',
    },
  },

  // oa 模版配置 新增模版
  {
    path: '/behaviorManage/oa-add-template/:id',
    name: 'behaviorManageOaAddTemplate',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageOaAddTemplate" */
      //   '@/views/behaviorManage/OaAddTemplate.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManageOaAddTemplate" */
        '@/views/behavior-manage/oa-work-manage/oa-template-config/Add.vue'
      ),
    meta: {
      SecondaryMenu: 'OA办公', //二级菜单
      title: '新增模版',
      breadcrumb: [{
        title: 'OA模版配置',
        name: 'behaviorManageOaTemplateList',
      }, ],
    },
  },
  // oa 模版配置 模板字段关联设置
  {
    path: '/behaviorManage/functionModuleDeploy/controlRules/:meta_type/:id',
    name: 'controlRules',
    component: () =>
      // import(
      //   /*webpackChunkName:"functionModuleDeploy" */
      //   '@/views/behaviorManage/controlRules.vue'
      // ),
      import(
        /*webpackChunkName:"functionModuleDeploy" */
        '@/views/behavior-manage/oa-work-manage/oa-template-config/FieldAssociation.vue'
      ),
    meta: {
      isMoreMeta: true,
      1: {
        SecondaryMenu: '系统设置', //二级菜单
        title: '模板字段关联设置',
        breadcrumb: [{
            title: '功能模块配置',
            name: 'functionModuleDeploy',
          },
          {
            title: '拜访模版',
            name: 'functionModuleDeployTemplateList',
          },
        ],
      },
      2: {
        SecondaryMenu: '系统设置', //二级菜单
        title: '模板字段关联设置',
        breadcrumb: [{
            title: '功能模块配置',
            name: 'functionModuleDeploy',
          },
          {
            title: '协访模版',
            name: 'functionModuleDeployTemplateList',
          },
        ],
      },
      3: {
        SecondaryMenu: '系统设置', //二级菜单
        title: '模板字段关联设置',
        breadcrumb: [{
            title: '功能模块配置',
            name: 'functionModuleDeploy',
          },
          {
            title: '活动形式配置',
            name: 'functionModuleDeployTemplateList',
          },
          {
            title: '管理活动模版',
            name: 'ManagementActivityTemplate',
          },
        ],
      },
      4: {
        SecondaryMenu: 'OA办公', //二级菜单
        title: '模板字段关联设置',
        breadcrumb: [{
          title: 'OA模版配置',
          name: 'behaviorManageOaTemplateList',
        }, ],
      },
    },
  },

  // oa 模版配置 审批流设置
  {
    path: '/behaviorManage/oa/approval/:id/:name',
    name: 'behaviorManageOaApproval',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageOa" */
      //   '@/views/behaviorManage/oa/Approval.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManageOa" */
        '@/views/behavior-manage/oa-work-manage/oa-template-config/ApprovalProSet.vue'
      ),
    meta: {
      SecondaryMenu: 'OA办公', //二级菜单
      title: '审批流设置',
      breadcrumb: [{
        title: 'OA模版配置',
        name: 'behaviorManageOaTemplateList',
      }, ],
    },
  },
  // OA 调查问卷
  {
    path: '/behaviorManage/survey-questionnaire-list',
    name: 'behaviorManageSurveyQuestionnaireList',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageSurveyQuestionnaireList" */
      //   '@/views/behaviorManage/survey-questionnaire/list.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManageSurveyQuestionnaireList" */
        '@/views/behavior-manage/oa-work-manage/question-investigat/Page.vue'
      ),
    meta: {
      SecondaryMenu: '内容管理', //二级菜单
      title: '调查问卷',
    },
  },
  // OA 调查问卷-数据结果
  {
    path: '/behaviorManage/questionnaire-result/:id/:type/:activity_id/:isFrom',
    name: 'behaviorManageQuestionnaireResult',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageQuestionnaireResult" */
      //   '@/views/behaviorManage/survey-questionnaire/result.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManageQuestionnaireResult" */
        '@/views/behavior-manage/oa-work-manage/question-investigat/Result.vue'
      ),
    meta: {
      SecondaryMenu: 'OA办公', //二级菜单
      title: '数据结果',
      breadcrumb: [{
        title: '调查问卷',
        name: 'behaviorManageSurveyQuestionnaireList',
      }, ],
    },
  },
  // OA 调查问卷-新建问卷
  {
    path: '/behaviorManage/create-questionnaire/:id/:isFrom',
    name: 'behaviorManageCreateQuestionnaire',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageCreateQuestionnaire" */
      //   '@/views/behaviorManage/survey-questionnaire/CreateQuestionnaire.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManageCreateQuestionnaire" */
        '@/views/behavior-manage/oa-work-manage/question-investigat/Add.vue'
      ),
    meta: {
      SecondaryMenu: '内容管理', //二级菜单
      title: '新建问卷',
      breadcrumb: [{
        title: '调查问卷',
        name: 'behaviorManageSurveyQuestionnaireList',
      }, ],
    },
  },

  // OA 通知公告
  {
    path: '/behaviorManage/notice',
    name: 'behaviorManageNotice',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageNotice" */
      //   '@/views/behaviorManage/notice/Page.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManageNotice" */
        '@/views/behavior-manage/oa-work-manage/notice-announce/Page.vue'
      ),
    meta: {
      SecondaryMenu: 'OA办公', //二级菜单
      title: '通知公告',
    },
  },
  // OA 通知公告详情
  {
    path: '/behaviorManage/notice/detail/:crm_notice_id',
    name: 'behaviorManageNoticeDetail',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageNotice" */
      //   '@/views/behaviorManage/notice/Detail.vue'
      // ),  //待删除文件
      import(
        /*webpackChunkName:"behaviorManageNotice" */
        '@/views/behavior-manage/oa-work-manage/notice-announce/Detail.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: 'OA办公', //二级菜单
      title: '通知公告详情',
      breadcrumb: [{
        title: '通知公告',
        name: 'behaviorManageNotice',
      }, ],
    },
  },
  // OA 通知公告编辑
  // meta_type 1-添加 2-编辑
  {
    path: '/behaviorManage/notice/edit/:meta_type/:crm_notice_id',
    name: 'behaviorManageNoticeEdit',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageNotice" */
      //   '@/views/behaviorManage/notice/Edit.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManageNotice" */
        '@/views/behavior-manage/oa-work-manage/notice-announce/Edit.vue'
      ),
    meta: {
      SecondaryMenu: 'OA办公', //二级菜单
      isMoreMeta: true,
      1: {
        title: '添加公告',
        breadcrumb: [{
          title: '通知公告',
          name: 'behaviorManageNotice',
        }, ],
      },
      2: {
        title: '编辑公告',
        breadcrumb: [{
            title: '通知公告',
            name: 'behaviorManageNotice',
          },
          {
            title: '通知公告详情',
            name: 'behaviorManageNoticeDetail',
          },
        ],
      },
    },
  },
  // OA 通知公告回执人员列表
  {
    path: '/behaviorManage/notice/receipt-list/:crm_notice_id',
    name: 'behaviorManageNoticeReceiptList',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageNotice" */
      //   '@/views/behaviorManage/notice/ReceiptList.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManageNotice" */
        '@/views/behavior-manage/oa-work-manage/notice-announce/ReceiptPersonneList.vue'
      ),
    meta: {
      SecondaryMenu: 'OA办公', //二级菜单
      title: '查看回执',
      breadcrumb: [{
        title: '通知公告',
        name: 'behaviorManageNotice',
      }, ],
    },
  },
  // 业务指导-业务指导列表
  {
    path: '/behaviorManage/business-guidance',
    name: 'behaviorManageBusinessGuidance',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageBusinessGuidance" */
      //   '@/views/behaviorManage/business-guidance/List'
      // ),
      import(
        /*webpackChunkName:"behaviorManageBusinessGuidance" */
        '@/views/behavior-manage/oa-work-manage/business-guidance/Page.vue'
      ),
    meta: {
      SecondaryMenu: 'OA办公', //二级菜单
      title: '业务指导列表',
    },
  },
  // 业务指导-导入指导
  {
    path: '/behaviorManage/business-guidance/import',
    name: 'behaviorManageBusinessGuidanceImport',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageBusinessGuidance" */
      //   '@/views/behaviorManage/business-guidance/Import'
      // ),
      import(
        /*webpackChunkName:"behaviorManageBusinessGuidance" */
        '@/views/behavior-manage/oa-work-manage/business-guidance/Import.vue'
      ),
    meta: {
      SecondaryMenu: 'OA办公', //二级菜单
      title: '导入指导',
      breadcrumb: [{
        title: '业务指导列表',
        name: 'behaviorManageBusinessGuidance',
      }, ],
    },
  },
  // 业务指导-配置指导部门
  {
    path: '/behaviorManage/business-guidance/department-config',
    name: 'behaviorManageBusinessGuidanceDpConfig',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageBusinessGuidance" */
      //   '@/views/behaviorManage/business-guidance/DepartmentConfig'
      // ),
      import(
        /*webpackChunkName:"behaviorManageBusinessGuidance" */
        '@/views/behavior-manage/oa-work-manage/business-guidance/Edit.vue'
      ),
    meta: {
      SecondaryMenu: 'OA办公', //二级菜单
      title: '配置指导部门',
      breadcrumb: [{
        title: '业务指导列表',
        name: 'behaviorManageBusinessGuidance',
      }, ],
    },
  },
  // 业务指导-详情
  {
    path: '/behaviorManage/business-guidance/detail/:crm_direct_id',
    name: 'behaviorManageBusinessGuidanceDetail',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageBusinessGuidanceDetail" */
      //   '@/views/behaviorManage/business-guidance/Detail'
      // ),
      import(
        /*webpackChunkName:"behaviorManageBusinessGuidanceDetail" */
        '@/views/behavior-manage/oa-work-manage/business-guidance/Detail.vue'
      ),
    meta: {
      SecondaryMenu: 'OA办公', //二级菜单
      title: '业务指导详情',
      breadcrumb: [{
        title: '业务指导列表',
        name: 'behaviorManageBusinessGuidance',
      }, ],
    },
  },
]
export default workManageRouter